/**
 * HTML escape utility for preventing XSS attacks
 */

/**
 * Escapes HTML special characters to prevent XSS
 * @param {*} value - The value to escape
 * @returns {string} The escaped string
 */
export const escapeHtml = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  const str = String(value);
  const htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "/": "&#x2F;",
  };

  return str.replace(/[&<>"'/]/g, (char) => htmlEscapes[char]);
};

/**
 * Creates a safe HTML string by escaping all dynamic values
 * Use this when building HTML strings with user data
 * @param {TemplateStringsArray} strings - Template literal strings
 * @param {...*} values - Values to escape and interpolate
 * @returns {string} Safe HTML string
 */
export const safeHtml = (strings, ...values) => {
  return strings.reduce((result, str, i) => {
    const value = i < values.length ? escapeHtml(values[i]) : "";
    return result + str + value;
  }, "");
};
